module.exports = __webpack_public_path__ + "static/media/Slice6@2x.59629a0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_209/images/Slice6@2x.png
// module id = 1731
// module chunks = 0